import { render, staticRenderFns } from "./Runtime.vue?vue&type=template&id=2f119a3b&"
import script from "./Runtime.vue?vue&type=script&lang=js&"
export * from "./Runtime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports